import { shallowEqual, useSelector } from 'react-redux';

import {
  FEATURE_EMOJI_RESTRICTIONS,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import type { AppState } from 'src/types/appState';

export const shouldRestrictEmojis = (
  isEmojiRestrictionsFeatureOn: boolean,
  flowType: AppState['formData']['flowType'],
) => isEmojiRestrictionsFeatureOn && flowType === 'create';

export const useEmojiRestrictionsFeature = () => {
  const { flowType } = useSelector(
    (state: AppState) => ({
      flowType: state.formData.flowType,
    }),
    shallowEqual,
  );

  const isEmojiRestrictionsFeatureOn = useFeatureToggleData(
    FEATURE_EMOJI_RESTRICTIONS,
  );

  const restrictEmojis = shouldRestrictEmojis(
    isEmojiRestrictionsFeatureOn,
    flowType,
  );

  return { shouldRestrictEmojis: restrictEmojis };
};
